/* APIRoutes
* Use create/retrieve/update/delete keywords for api prop name and follow the module screen hierarchy.
* if same api is used for multiple operations, define it once with the prop name in short form
*  (e.g cu, cd,cud, crud)
*/

export const APIRoutes = {
    movementEnquiry: {
        transactions: {
            lines: {
                retrieve: 'InventoryEnquiry/Product/:ProductId/Movements/:MovementId/Transactions',
            },
        },
        binLocation: {
            lines: {
                retrieve: 'InventoryEnquiry/Product/:ProductId/Movements/:MovementId/LineNumber/:LineNumber/BinLocation',
            },
        },
        lot: {
            lines: {
                retrieve: 'InventoryEnquiry/Product/:ProductId/Movements/:MovementId/LineNumber/:LineNumber/Lot',
            },
        },
        serial: {
            lines: {
                retrieve: 'InventoryEnquiry/Product/:ProductId/Movements/:MovementId/LineNumber/:LineNumber/Serial',
            },
        },
        summary: {
            retrieve: 'InventoryEnquiry/Product/:ProductId/Movements/:MovementId/LineNumber/:LineNumber/Summary',
        },
    }
};
